$(function () {
    if ($('#WaitlistDetailsForm').length > 0) {
        app.Waitlist_UpdateFrequency("@Model.AgeGroupTypeCd" == jsSchoolAgeCd)

        $("#ContactRequestButton").click(function (e) {
            e.stopPropagation();
            e.preventDefault();

            $("#confirmModal").modal({
                'backdrop': 'static'
            });

            return false;
        });
    }

    if ($('#WaitlistSearchForm').length > 0) {
        $('#SelectedCommunities').select2({
            allowClear: false,
            multiple: true,
            language: '@Model.Lang',
            dropdownAutoWidth: true,
            theme: 'bootstrap4',
            selectionCssClass: 'highlighted',
            width: '100%'
        });

        $("#AgeGroupTypeCd").change(function () {

            $(".frequencydiv").addClass("d-none");
            $(".exactmatchdiv").addClass("d-none");

            var id = $(this).val();

            if (id != jsDefaultAgeCd) {

                $(".frequencydiv").removeClass("d-none");
                $(".exactmatchdiv").removeClass("d-none");
            }

            app.Waitlist_UpdateFrequency($(this).val() == jsSchoolAgeCd)
        });
        $("#AgeGroupTypeCd").change();

        $("#HideResultsContacted").change(function () {
            $('#WaitlistSearchForm').submit();
        });

        $("#HideResultsIndictedNotAMatch").change(function () {
            $('#WaitlistSearchForm').submit();
        });

        $("select[name=PageSize]").on('change', function (e) {
            $("#WaitlistSearchForm").submit();
        });

        //$(".btnSearch").click(function () {

        //    $(".resultsdiv").removeClass("d-none");

        //});
    } 
}); // $(function () {